import { PortfolioRepo as portfolioRepo } from "./portfolio.repo";
import { PortfolioUtilities as portfolioUtilities } from "../common/portfolio.utilities";
import * as _ from "lodash";
import { portfolioSelectorService } from "./portfolioSelector";
import * as echarts from "echarts";
import * as moment from "moment";
import {
  AssetClassNames,
  AssetClassColour,
  AssetClassColourArray,
} from "../common/enums/AssetClassType";
import { isNullOrUndefined } from "util";

class PortfolioSummaryController implements angular.IOnInit {
  public regionalSummaryChart: any;
  public regionalSummaryChartOptions: any;

  public clientNumber: string;
  public portfolios: any;
  public mauritiusTotal: any;
  public internationalTotal: any;
  public mauritiusPercentage: any;
  public internationalPercentage: any;
  public currencies: any;
  public performance: any;

  public assetClass: any;
  public assetClassChartHeight: any;
  public assetClassesTotal: any;
  scope: any;

  public minScreenWidth: any;
  public pieFontSize: any;

  // colour variables:
  public confidentGrey = "#00475a";
  public confidentRedTint = "#91c840";

  // colour array
  public colourArray: any[];

  //currency
  public get selectedCurrency(): string {
    return this.portfolioSelectorService.getSelectedCurrency();
  }

  //performance date ranges

  public fromDate;
  public toDate;
  public quarterNumber;

  /** @ngInject */
  constructor(
    private portfolioRepo: portfolioRepo,
    private portfolioUtilities: portfolioUtilities,
    private portfolioSelectorService: portfolioSelectorService,
    private $state: angular.ui.IStateService,
    private notifyjs
  ) {
    this.minScreenWidth = 400;

    // fill colour array
    this.colourArray = AssetClassColourArray;

    var regionalChartHeight: any = "40%";
    var chartWidth = "50%";
    var that = this;
    that.assetClassChartHeight = "50%";

    // that.updateUserPortfolios();

    this.portfolioSelectorService.registerCallback("portfolioSummary", () => {
      this.updateData();
      // this.updatePerformanceData();
      this.updateUserPortfolios();
    });

    // initialise the echarts component and then you can set the options later.
    // The dom element gets initialised and you can now set options and interact with the pie-chart
    that.regionalSummaryChart = echarts.init(
      document.getElementById("regional-summary-pie-chart")
    );

    //setting the click events for echarts here.
    that.regionalSummaryChart.on("click", function (params) {
      if (params.data.name == "Mauritius") {
        $state.go("root.portfolio.portfolioSummary.mauritius");
      } else {
        $state.go("root.portfolio.portfolioSummary.international");
      }
      return;
    });

    // set the from data from the beggining of this year and the end date being the last months last day.

    var date = new Date();
    this.fromDate = moment().startOf("year").format("YYYY-MM-DD");
    this.toDate = moment().add(-1, "days").format("YYYY-MM-DD");
    this.quarterNumber = moment(this.toDate).utc().quarter();
    // moment(date).subtract(1,'months').endOf('month').format('YYYY-MM-DD')
  }

  $onInit() {
    this.updateData();
    this.updatePerformanceData();
    this.updateUserPortfolios();
  }

  updateUserPortfolios() {
    this.portfolioRepo.getUserPortfolios().then((val) => {
      let ids = new Array<any>();
      if (val) {
        let portfolios: any = {};
        let resp = val.data;

        _.each(resp, (client: any) => {
          this.clientNumber = client.clientNumber;
          if (client != null && client.portfolios && client.portfolios.length)
            _.each(client.portfolios, (portfolio) => {
              portfolios[portfolio.id] = portfolio.name;
            });
        });
      }
    });
  }

  updateData() {
    let that = this;
    this.portfolioSelectorService.setIsLoading(true);
    this.portfolioRepo
      .getPortfolioAggregatesByLocality(
        null,
        this.portfolioSelectorService.getSelectedCurrency(),
        this.portfolioSelectorService.getSelectedPortfolios()
      )
      .then((val) => {
        that.portfolios = val;
        that.mauritiusTotal = 0;
        that.internationalTotal = 0;

        _.forEach(that.portfolios, (portfolio) => {
          if (portfolio.name == "Local")
            // Mauritius
            that.mauritiusTotal = portfolio.total;
          else that.internationalTotal = portfolio.total;
        });

        that.mauritiusPercentage =
          (that.mauritiusTotal /
            (that.mauritiusTotal + that.internationalTotal)) *
          100;
        that.internationalPercentage =
          (that.internationalTotal /
            (that.mauritiusTotal + that.internationalTotal)) *
          100;

        if (window.screen.width > 1920) {
          // to be replaced with Retina condition
          this.pieFontSize = 24;
        } else {
          this.pieFontSize = 12;
        }

        if (window.screen.width > this.minScreenWidth) {
          that.regionalSummaryChartOptions = {
            tooltip: {
              trigger: "item",
              formatter: "{b} : {d}%",
            },
            grid: {
              containLabel: true,
            },
            series: {
              type: "pie",
              radius: ["40%", "60%"],
              center: ["50%", "50%"],
              labelLine: {
                normal: {
                  show: true,
                },
              },
              label: {
                normal: {
                  fontSize: this.pieFontSize,
                },
              },
              data: [
                {
                  name: "Mauritius",
                  value: that.mauritiusPercentage,
                  itemStyle: {
                    normal: {
                      color: that.confidentGrey,
                      fontFamily: "Helvetica",
                    },
                  },
                },
                {
                  name: "International",
                  value: that.internationalPercentage,
                  itemStyle: {
                    normal: {
                      color: that.confidentRedTint,
                      fontFamily: "Helvetica",
                    },
                  },
                },
              ],
            },
          };
        } else {
          that.regionalSummaryChartOptions = {
            tooltip: {
              trigger: "item",
              formatter: "{b} : {d}%",
            },
            grid: {
              containLabel: true,
            },
            series: {
              type: "pie",
              radius: ["40%", "60%"],
              center: ["50%", "50%"],
              labelLine: {
                normal: {
                  show: false,
                },
              },
              label: {
                normal: {
                  show: false,
                },
              },
              data: [
                {
                  name: "Mauritius",
                  value: that.mauritiusPercentage,
                  itemStyle: {
                    normal: {
                      color: that.confidentGrey,
                      fontFamily: "Helvetica",
                    },
                  },
                },
                {
                  name: "International",
                  value: that.internationalPercentage,
                  itemStyle: {
                    normal: {
                      color: that.confidentRedTint,
                      fontFamily: "Helvetica",
                    },
                  },
                },
              ],
            },
          };
        }
        that.regionalSummaryChart.setOption(that.regionalSummaryChartOptions);
        this.portfolioSelectorService.setIsLoading(false);
      })
      .catch(() => {
        this.portfolioSelectorService.setIsLoading(false);
        this.notifyjs(
          "The data for the selected portfolios could not be loaded. Please try again later or contact the System Administrator.",
          "error"
        );
      });

    this.portfolioRepo
      .getPortfolioAggregatesByAssetClasses(
        null,
        this.portfolioSelectorService.getSelectedCurrency(),
        null,
        this.portfolioSelectorService.getSelectedPortfolios()
      )
      .then((val) => {
        this.assetClass = val as Array<any>;

        this.assetClassesTotal = _.reduce(
          this.assetClass,
          (prev, next) => {
            return prev + next.total;
          },
          0
        );

        this.portfolioSelectorService.setIsLoading(false);
      })
      .catch((err) => {
        this.portfolioSelectorService.setIsLoading(false);
        this.notifyjs(
          "The data for the selected portfolios could not be loaded. Please try again later or contact the System Administrator.",
          "error"
        );
      });
  }

  public updatePerformanceData() {
    this.portfolioSelectorService.setIsLoading(true);
    this.portfolioRepo
      .getPortfolioPerformance(
        this.portfolioSelectorService.getSelectedCurrency(),
        this.portfolioSelectorService.getSelectedPortfolios(),
        this.fromDate,
        this.toDate
      )
      .then((val) => {
        this.performance = val.data;
      })
      .catch((err) =>
        this.notifyjs(
          "The data for the selected portfolios could not be loaded. Please try again later or contact the System Administrator.",
          "error"
        )
      )
      .finally(() => this.portfolioSelectorService.setIsLoading(false));
  }

  public getPercentageFromDecimal(decimal: number) {
    return decimal * 100;
  }

  public formatCurrency() {
    if (!this.portfolioSelectorService.isLoading) {
      return this.portfolioUtilities.formatCurrency(
        this.portfolioSelectorService.getSelectedCurrency()
      );
    } else {
      return "";
    }
  }

  public getAssetClassPercentage(assetClass) {
    return (assetClass.total / this.assetClassesTotal) * 100;
  }

  public getAssetClassTotal(assetClassTotals, assetClassName) {
    let assetClassTotal = assetClassTotals.find(
      (assetClass) => assetClass.name == assetClassName
    );
    return isNullOrUndefined(assetClassTotal) ? 0 : assetClassTotal;
  }

  public commaSep(value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  public stateChange(stateName: string) {
    this.$state.go(stateName);
    return;
  }

  public formatName(name: string) {
    return _.startCase(name);
  }
}

export const portfolioSummary: angular.IComponentOptions = {
  template: require("./portfolioSummary.html"),
  controller: PortfolioSummaryController,
};



// WEBPACK FOOTER //
// ./src/app/portfolio/portfolioSummary.ts